
import React, { createContext, useState, useEffect } from "react";

//import { Plugins } from '@capacitor/core';

import { Preferences } from '@capacitor/preferences'

//const { Storage } = Plugins;

import Cookie from 'universal-cookie';
import { useHistory} from "react-router-dom";


let cookies = new Cookie();

async function removeStorageCredentials() {


    await Preferences.remove({ key: 'accountID' });
    await Preferences.remove({ key: 'company_phoneNumber' });
    await Preferences.remove({ key: 'mtnCompany_phoneNumber' });
    await Preferences.remove({ key: 'employeeID' });
    await Preferences.remove({ key: 'employee_first_name' });
    await Preferences.remove({ key: 'employee_last_name' });
    await Preferences.remove({ key: 'employee_company' });
    await Preferences.remove({ key: 'employee_createdBy' });
    await Preferences.remove({ key: 'schemaName' });
    await Preferences.remove({ key: 'isAuthenticated' });
    await Preferences.remove({ key: 'accessRights' });
    await Preferences.remove({ key: 'loginUsername_authenticated' });
    await Preferences.remove({ key: 'loginPassword_authenticated' });
    await Preferences.remove({ key: 'isBiometricFingerprintAvilable' });
    await Preferences.remove({ key: 'biometricFingerprint' });
    await Preferences.remove({ key: 'device' });
    await Preferences.remove({ key: 'sessionID' });
    await Preferences.remove({ key: 'session' });
    await Preferences.remove({ key: 'baseURL' });
    await Preferences.remove({ key: 'capability' });
    await Preferences.remove({ key: 'feature' });
    await Preferences.remove({ key: 'cartList' });
    await Preferences.remove({ key: 'fcm_token' });
    await Preferences.remove({ key: 'latitude_current' });
    await Preferences.remove({ key: 'longitude_current' });
    await Preferences.remove({ key: 'chatID_list' });
    await Preferences.remove({ key: 'websocket' });
    await Preferences.remove({ key: 'initial_setup' });
    await Preferences.remove({ key: 'selected_tutorial' });
    await Preferences.remove({ key: 'subscription' });


    let remove_cookie = null;

    cookies.remove('session', remove_cookie);


}

async function getStorageCredentials() {


    const  stored_accountID  = await Preferences.get({ key: 'accountID' });
    const  stored_companyPhoneNumber = await Preferences.get({key: 'company_phoneNumber'});
    const  stored_mtnCompanyPhoneNumber = await Preferences.get({key: 'mtnCompany_phoneNumber'});
    const  stored_employeeID  = await Preferences.get({ key: 'employeeID' });
    const  stored_employeeFirstName  = await Preferences.get({ key: 'employee_first_name' });
    const  stored_employeeLastName  = await Preferences.get({ key: 'employee_last_name' });
    const  stored_employeeCompany  = await Preferences.get({ key: 'employee_company' });

    const  stored_employeeCreatedBy  = await Preferences.get({ key: 'employee_createdBy' });
    const  stored_schemaName  = await Preferences.get({ key: 'schemaName' });
    const  stored_isAuthenticated  = await Preferences.get({ key: 'isAuthenticated' });
    const  stored_accessRights  = await Preferences.get({ key: 'accessRights' });
    //const stored_accessRights = await Preferences.get({ key: 'accessRights' }) == "false" ? false : []


    const  stored_loginUsername_Authenticated  = await Preferences.get({ key: 'loginUsername_authenticated' });
    const  stored_loginPassword_Authenticated  = await Preferences.get({ key: 'loginPassword_authenticated' });

    const stored_isBiometric_fingerprintAvailable = await Preferences.get({ key: 'isBiometricFingerprintAvilable' });
    const stored_biometric_fingerprint = await Preferences.get({ key: 'biometricFingerprint' });
    //const stored_device = await Preferences.get({ key: 'device' }) == "true" ? true : false

   // const  stored_isBiometric_fingerprintAvailable  = await Preferences.get({ key: 'isBiometricFingerprintAvilable' });
   // const  stored_biometric_fingerprint  = await Preferences.get({ key: 'biometricFingerprint' });
    const  stored_device  = await Preferences.get({ key: 'device' });
    const  stored_sessionID  = await Preferences.get({ key: 'sessionID' });
    const  stored_session  = await Preferences.get({ key: 'session' });
    const  stored_baseURL  = await Preferences.get({ key: 'baseURL' });

    const  stored_capability  = await Preferences.get({ key: 'capability' });
    const  stored_freature  = await Preferences.get({ key: 'feature' });

    const  stored_cartList  = await Preferences.get({ key: 'cartList' });
    const  stored_fcmToken = await Preferences.get({key: 'fcm_token'});

    const  stored_latitudeCurrent = await Preferences.get({key: 'latitude_current'});
    const  stored_longitudeCurrent = await Preferences.get({key: 'longitude_current'});

    const  stored_chatID_list = await Preferences.get({key: 'chatID_list'});
    //const  stored_websocket = await Preferences.get({key: 'websocket'});
    const  stored_initialSetup = await Preferences.get({key: 'initial_setup'});

    const  stored_selectedTutorial = await Preferences.get({key: 'selected_tutorial'});
    const  stored_subscription = await Preferences.get({key: 'subscription'});


    if(stored_accessRights.value == null)
    {
        // alert('In stored_accessRights.value == null');
        //  alert(stored_isAuthenticated.value);
        //   alert(stored_initialSetup.value);
        // alert(stored_cartList.value.toString());
        // alert(JSON.parse(stored_cartList.value));
        // alert(JSON.parse(stored_cartList.value).price);
        // alert(stored_cartList.toString());

        let initialSetupParsed = {};
        let selectedTutorialParsed = {};
        let subscriptionParsed = {};

            try {
            initialSetupParsed = stored_initialSetup.value
                ? JSON.parse(stored_initialSetup.value)
                : {};

            if (typeof initialSetupParsed.details === 'string') {
                initialSetupParsed.details = JSON.parse(initialSetupParsed.details);
            }
            } catch (e) {
            console.warn('Error parsing initialSetup:', e);
            initialSetupParsed = {};
            }


            try {
                selectedTutorialParsed = stored_selectedTutorial.value
                    ? JSON.parse(stored_selectedTutorial.value)
                    : {};

                if (typeof selectedTutorialParsed.details === 'string') {
                    selectedTutorialParsed.details = JSON.parse(selectedTutorialParsed.details);
                }
                } catch (e) {
                console.warn('Error parsing selectedTutorial:', e);
                selectedTutorialParsed = {};
                }

            try {
                subscriptionParsed = stored_subscription.value
                    ? JSON.parse(stored_subscription.value)
                    : {};
    
                if (typeof subscriptionParsed.details === 'string') {
                    subscriptionParsed.details = JSON.parse(subscriptionParsed.details);
                }
                } catch (e) {
                console.warn('Error parsing subscription:', e);
                subscriptionParsed = {};
                }


        let storageObjects = {
            accountID: stored_accountID.value,
            companyPhoneNumber: stored_companyPhoneNumber.value,
            mtnCompanyPhoneNumber: stored_mtnCompanyPhoneNumber.value,
            employeeID: stored_employeeID.value,
            employeeFirstName: stored_employeeFirstName.value,
            employeeLastName: stored_employeeLastName.value,
            employeeCompany: stored_employeeCompany.value,

            employeeCreatedBy: stored_employeeCreatedBy.value,
            schemaName: stored_schemaName.value,
            isAuthenticated: stored_isAuthenticated.value,
            accessRights: stored_accessRights.value,
            //accessRights: stored_accessRights.value,
            loginUsername_Authenticated: stored_loginUsername_Authenticated.value,
            loginPassword_Authenticated: stored_loginPassword_Authenticated.value,
            //isBiometric_fingerprintAvailable_authenticated: JSON.parse(stored_isBiometric_fingerprintAvailable.value),
            isBiometric_fingerprintAvailable_authenticated: stored_isBiometric_fingerprintAvailable.value,
            biometric_fingerprint_authenticated: stored_biometric_fingerprint.value,
            device_authenticated: stored_device.value,
            sessionID_authenticated: stored_sessionID.value,
            session_authenticated: stored_session.value,
            baseURL_authenticated: stored_baseURL.value,
            capability_authenticated: stored_capability.value,
            feature_authenticated: stored_freature.value,
            cartList_authenticated: stored_cartList.value ? JSON.parse(stored_cartList.value) : [],
            fcmToken_authenticated: stored_fcmToken.value,
            latitudeCurrent_authenticated: stored_latitudeCurrent.value,
            longitudeCurrent_authenticated: stored_longitudeCurrent.value,

            chatID_list_authenticated: stored_chatID_list.value,
            //websocket_authenticated: stored_websocket.value,
            initialSetup_authenticated: initialSetupParsed,
            selectedTutorial_authenticated: selectedTutorialParsed,
            subscription_authenticated: subscriptionParsed

        }

        return storageObjects;

    }
    else
    {
        //  alert('In stored_accessRights.value NOT EQUAL TO null');
        //  alert(stored_selectedTutorial.value);
        //  alert(JSON.parse(stored_selectedTutorial.value.details));
        // alert(stored_initialSetup.value);
        // alert(stored_isAuthenticated.value);
        // alert(stored_longitudeCurrent.value);
        // alert(stored_accessRights.value.toString().split(','));
        //   alert(stored_device.value);
        //  alert(stored_isAuthenticated.value);
        //  alert(stored_freature.value.toString().split(','));
        //  alert(stored_cartList.value.toString());
        let initialSetupParsed = {};
        let selectedTutorialParsed = {};
        let subscriptionParsed = {};

        try {
        initialSetupParsed = stored_initialSetup.value
            ? JSON.parse(stored_initialSetup.value)
            : {};

        if (typeof initialSetupParsed.details === 'string') {
            initialSetupParsed.details = JSON.parse(initialSetupParsed.details);
        }
        } catch (e) {
        console.warn('Error parsing initialSetup:', e);
        initialSetupParsed = {};
        }


        try {
            selectedTutorialParsed = stored_selectedTutorial.value
                ? JSON.parse(stored_selectedTutorial.value)
                : {};
    
            if (typeof selectedTutorialParsed.details === 'string') {
                selectedTutorialParsed.details = JSON.parse(selectedTutorialParsed.details);
            }
            } catch (e) {
            console.warn('Error parsing selectedTutorial:', e);
            selectedTutorialParsed = {};
            }

        try {
            subscriptionParsed = stored_subscription.value
                ? JSON.parse(stored_subscription.value)
                : {};
    
            if (typeof subscriptionParsed.details === 'string') {
                subscriptionParsed.details = JSON.parse(subscriptionParsed.details);
            }
            } catch (e) {
            console.warn('Error parsing subscription:', e);
            subscriptionParsed = {};
            }

        let storageObjects = {
            accountID: stored_accountID.value,
            companyPhoneNumber: stored_companyPhoneNumber.value,
            mtnCompanyPhoneNumber: stored_mtnCompanyPhoneNumber.value,
            employeeID: stored_employeeID.value,
            employeeFirstName: stored_employeeFirstName.value,
            employeeLastName: stored_employeeLastName.value,
            employeeCompany: stored_employeeCompany.value,

            employeeCreatedBy: stored_employeeCreatedBy.value,
            schemaName: stored_schemaName.value,
            isAuthenticated: stored_isAuthenticated.value,
            accessRights: stored_accessRights.value.toString().split(','),
            //accessRights: stored_accessRights.value,
            loginUsername_Authenticated: stored_loginUsername_Authenticated.value,
            loginPassword_Authenticated: stored_loginPassword_Authenticated.value,
            //isBiometric_fingerprintAvailable_authenticated: JSON.parse(stored_isBiometric_fingerprintAvailable.value),
            isBiometric_fingerprintAvailable_authenticated: stored_isBiometric_fingerprintAvailable.value,
            biometric_fingerprint_authenticated: stored_biometric_fingerprint.value,
            device_authenticated: stored_device.value,
            sessionID_authenticated: stored_sessionID.value,
            session_authenticated: stored_session.value.toString().split(','),
            baseURL_authenticated: stored_baseURL.value,
            capability_authenticated: stored_capability.value.toString().split(','),
            feature_authenticated: stored_freature.value.toString().split(','),
            cartList_authenticated: stored_cartList.value ? JSON.parse(stored_cartList.value) : [],
            fcmToken_authenticated: stored_fcmToken.value,
            latitudeCurrent_authenticated: stored_latitudeCurrent.value,
            longitudeCurrent_authenticated: stored_longitudeCurrent.value,

            chatID_list_authenticated: stored_chatID_list.value,
            //websocket_authenticated: stored_websocket.value,
            initialSetup_authenticated: initialSetupParsed,
            selectedTutorial_authenticated: selectedTutorialParsed,
            subscription_authenticated: subscriptionParsed



        }
        
        return storageObjects;

    }


}


export const Auth_MerchantID_context = createContext({
    acctID: null,
    companyPhoneNumber: null,
    mtnCompanyPhoneNumber: null,
    employeeID: null,
    employeeFirstName: null,
    employeeLastName: null,
    employeeCompany: null,

    schema: null,
    accessRights: [],
    cookieID: null,
    authenticated: null,
    loginUsername: null,
    loginPassword: null,

    isBiometric_fingerprintAvailable: null,
    biometric_fingerprint: null,
    device: null,
    sessionID: null,
    session: null,
    baseURL: '',

    startDate: new Date(),
    endDate: new Date(),
    numOfNights: null,
    capability: [],
    feature: [],
    cartList: [],
    fcmToken: null,
    latitudeCurrent: null,
    longitudeCurrent: null,

    chatID_list: null,
    websocket: null,
    initialSetup: [],
    selectedTutorial: [],
    subscription: [],

    changeAccountID: (data_id) => {},
    changeCompanyPhoneNumber: (data_companyPhoneNumber) => {},
    changemtnCompanyPhoneNumber: (data_mtnCompanyPhoneNumber) => {},
    changeEmployeeID: (data_empID) => {},
    changeEmployeeFirstName: (data_empFirstName) => {},
    changeEmployeeLastName: (data_empLastName) => {},
    changeEmployeeCompany: (data_empCompany) => {},

    changeEmployeeCreatedBy: (data_employeeCreatedBy) => {},

    changeSchema: (data_schema) => {},
    changeAccessRights: (data_accessRights) => {},
    changeCookieID: (data_schema) => {},
    changeAuthenticated: (data_auth) => {},
    changeLoginUsername: (data_username) => {},
    changeLoginPassword: (data_password) => {},

    changeIsBiometric_fingerprintAvilable: (data_isBiometric_fingerprintAvailable) => {},
    changeBiometric_fingerprint: (data_biometric_fingerprint) => {},
    changeDevice: (data_device) => {},
    changeSessionID: (data_sessionID) => {},
    changeSession: (data_session) => {},
    changeBaseURL: (data_baseURL) => {},

    changeStartDateRange: (data_startDate) => {},
    changeEndDateRange: (data_endDate) => {},
    changeNumOfNights: (data_numOfNights) => {},

    changeCapability: (data_capability) => {},
    changeFeature: (data_feature) => {},

    changeCartList: (data_cartList) => {},

    changeFcmToken: (data_id) => {},

    changeLatitudeCurrent: (data_latitudeCurrent) => {},
    changeLongitudeCurrent: (data_longitudeCurrent) => {},

    changeChatID_list: (data_chatID_list) => {},
    changeWebsocket: (data_websocket) => {},
    changeInitialSetup: (data_initialSetup) => {},
    changeSelectedTutorial: (data_selectedTutorial) => {},
    changeSubscription: (data_subscription) => {},


});

export function AuthenticatedMerchantProvider (props) {

    //alert('In AuthenticatedMerchantProvider');
    const [accountID, setAccountID ] = useState(null);
    const [companyPhoneNumber, setCompanyPhoneNumber ] = useState(null);
    const [mtnCompanyPhoneNumber, setMtnCompanyPhoneNumber ] = useState(null);
    const [employee_ID, setEmployeeID ] = useState(null);
    const [employee_FirstName, setEmployeeFirstName ] = useState(null);
    const [employee_LastName, setEmployeeLastName ] = useState(null);
    const [employee_Company, setEmployeeCompany ] = useState(null);

    const [employee_createdBy, setEmployeeCreatedBy ] = useState(null);

    const [schemaName, setSchemaName ] = useState(null);
    const [accessRightsData, setAccessRights ] = useState(['', '', '', '', '']);
    const [cookieIdentity, setCookieIdentity ] = useState(null);
    const [isAuthenticated, setIsAuthenticated ] = useState(null);
    const [loginUsername_Authenticated, setLoginUsername ] = useState(null);
    const [loginPassword_Authenticated, setLoginPassword ] = useState(null);

    const [isBiometric_fingerprintAvailable_authenticated, setIsBiometric_fingerprintAvailable ] = useState(null);
    const [biometric_fingerprint_authenticated, setBiometric_fingerprint ] = useState(null);
    const [device_authenticated, setDevice ] = useState(null);
    const [sessionID_authenticated, setSessionID ] = useState(null);
    const [session_authenticated, setSession ] = useState(null);
    const [baseURL_authenticated, setBaseURL ] = useState('');

    const [startDateRange, setStartDateRange ] = useState(new Date());
    const [endDateRange, setEndDateRange ] = useState(new Date());
    const [numberOfNights, setNumberOfNights ] = useState(null);

    const [capabilityData, setCapability ] = useState(['', '', '', '', '', '']);
    const [featureData, setFeature ] = useState(['', '']);

    const [cartListData, setCartList ] = useState([]);

    const [fcmToken_authenticated, setFcmToken ] = useState(null);

    const [latitudeCurrent, setLatitudeCurrent ] = useState(null);
    const [longitudeCurrent, setLongitudeCurrent ] = useState(null);

    const [chatID_list, setChatID_list ] = useState(null);
    const [websocket, setWebsocket ] = useState(null);
    const [initialSetup, setInitialSetup ] = useState([]);
    const [selectedTutorial, setSelectedTutorial ] = useState([]);
    const [subscription, setSubscription ] = useState([]);

    let history = useHistory();


    useEffect(() => {

        //removeStorageCredentials();

        getStorageCredentials().then(res => { 

            // alert('In auth_context useEffect getStorageCredentials');
            // alert(res?.initialSetup_authenticated ?? []);
            // alert(res?.selectedTutorial_authenticated ?? []);
            // alert(res?.subscription_authenticated ?? []);

            // alert(res?.baseURL_authenticated ?? '');
            // alert(res?.sessionID_authenticated ?? null);
            // alert(res?.session_authenticated ?? null);
            // alert(res?.device_authenticated ?? null);
            // alert(res.isBiometric_fingerprintAvailable_authenticated);
            // alert(res.biometric_fingerprint_authenticated);
            // alert(res?.accountID ?? null);
            // alert(res?.companyPhoneNumber ?? null);
            // alert(res?.employeeID ?? null);
            // alert(res?.employeeFirstName ?? null);
            // alert(res?.employeeLastName ?? null);
            // alert(res?.employeeCompany ?? null);
            // alert(res?.employeeCreatedBy ?? null);
            // alert(res?.schemaName ?? null);
            // alert(res?.loginUsername_Authenticated ?? null);
            // alert(res?.loginPassword_Authenticated ?? null);
            // alert(res?.accessRights ?? ['', '', '', '', '']);
            // alert(res.isAuthenticated);
            // alert(res?.capability_authenticated ?? ['', '', '', '', '', '']);
            // alert(res?.feature_authenticated ?? ['', '']);
            // alert(res?.cartList_authenticated ?? []);
            // alert(res?.fcmToken_authenticated ?? null);
            // alert(res?.latitudeCurrent_authenticated ?? null);
            // alert(res?.longitudeCurrent_authenticated ?? null);
            // alert(res?.chatID_list_authenticated ?? []);



            setInitialSetup(res?.initialSetup_authenticated ?? []);
            setSelectedTutorial(res?.selectedTutorial_authenticated ?? []);
            setSubscription(res?.subscription_authenticated ?? []);

            setBaseURL(res?.baseURL_authenticated ?? '');
            setSessionID(res?.sessionID_authenticated ?? null);
            setSession(res?.session_authenticated ?? null);
            setDevice(res?.device_authenticated ?? null);
            setIsBiometric_fingerprintAvailable(res.isBiometric_fingerprintAvailable_authenticated);
            setBiometric_fingerprint(res.biometric_fingerprint_authenticated);
            setAccountID(res?.accountID ?? null);
            setCompanyPhoneNumber(res?.companyPhoneNumber ?? null);
            setMtnCompanyPhoneNumber(res?.mtnCompanyPhoneNumber ?? null);
            setEmployeeID(res?.employeeID ?? null);
            setEmployeeFirstName(res?.employeeFirstName ?? null);
            setEmployeeLastName(res?.employeeLastName ?? null);
            setEmployeeCompany(res?.employeeCompany ?? null);
            setEmployeeCreatedBy(res?.employeeCreatedBy ?? null);
            setSchemaName(res?.schemaName ?? null);
            setLoginUsername(res?.loginUsername_Authenticated ?? null);
            setLoginPassword(res?.loginPassword_Authenticated ?? null);
            setAccessRights(res?.accessRights ?? ['', '', '', '', '']);
            setIsAuthenticated(res.isAuthenticated);
            setCapability(res?.capability_authenticated ?? ['', '', '', '', '', '']);
            setFeature(res?.feature_authenticated ?? ['', '']);
            setCartList(res?.cartList_authenticated ?? []);
            setFcmToken(res?.fcmToken_authenticated ?? null);
            setLatitudeCurrent(res?.latitudeCurrent_authenticated ?? null);
            setLongitudeCurrent(res?.longitudeCurrent_authenticated ?? null);
            setChatID_list(res?.chatID_list_authenticated ?? []);
            // setWebsocket(res?.websocket_authenticated ?? null);


            if (res.isAuthenticated === null || res.isAuthenticated === "null" || res.isAuthenticated === undefined) 
            {
                //alert("IN STORE STATE USEEFECT = NULL ");

                removeStorageCredentials();
                history.push('/');
                window.location.href = '/';
            }

        });

    }, [])
    

    function changeAccountIDHandler (data_id) {

        //alert('In changeAccountIDHandler');

        //setAccountID((prev) => { return data_id} );
        setAccountID(data_id);
    }
    function changeCompanyPhoneNumberHandler (data_companyPhoneNumber) {

        //alert('In changeAccountIDHandler');

        //setAccountID((prev) => { return data_id} );
        setCompanyPhoneNumber(data_companyPhoneNumber);
    }
    function changemtnCompanyPhoneNumberHandler (data_mtnCompanyPhoneNumber) {

        //alert('In changeAccountIDHandler');

        //setAccountID((prev) => { return data_id} );
        setMtnCompanyPhoneNumber(data_mtnCompanyPhoneNumber);
    }
    function changeEmployeeIDHandler (data_empID) {

        //setEmployeeID((prev) => { return data_empID} );
        setEmployeeID(data_empID);
    }
    function changeEmployeeFirstNameHandler (data_empFirstName) {

        //setEmployeeID((prev) => { return data_empID} );
        setEmployeeFirstName(data_empFirstName);
    }

    function changeEmployeeLastNameHandler (data_empLastName) {

        //setEmployeeID((prev) => { return data_empID} );
        setEmployeeLastName(data_empLastName);
    }

    function changeEmployeeCompanyHandler (data_empCompany) {

        //setEmployeeID((prev) => { return data_empID} );
        setEmployeeCompany(data_empCompany);
    }

    function changeEmployeeCreatedByHandler (data_schema) {

        setEmployeeCreatedBy(data_schema);
    }

    function changeSchemaNameHandler (data_schema) {

        //setSchemaName((prev) => { return data_schema} );
        setSchemaName(data_schema);
    }

    function changeAccessRightsHandler (data_accessRights) {

        //setAccessRights((prev) => { return data_accessRights} );
        setAccessRights(data_accessRights);
    }

    function changeCookieHandler(data_cookie) {

        //setCookieIdentity((prev) => { return data_cookie} );
        setCookieIdentity(data_cookie);
    }


    function changeAuthenticatedHandler(data_auth) {

        //setIsAuthenticated((prev) => { return data_auth} );
        // alert("in set auth");
        // alert(data_auth);
        setIsAuthenticated(data_auth);
    }


    function changeLoginUsernameHandler(data_username) {

        //setIsAuthenticated((prev) => { return data_auth} );
        setLoginUsername(data_username);
    }


    function changeLoginPasswordHandler(data_password) {

        //setIsAuthenticated((prev) => { return data_auth} );
        setLoginPassword(data_password);
    }



    function changeIsBiometric_fingerprintAvilable_handler(data_isBiometric_fingerprintAvailable) {

        //setIsAuthenticated((prev) => { return data_auth} );
        setIsBiometric_fingerprintAvailable(data_isBiometric_fingerprintAvailable);
    }

    function changeBiometric_fingerprint_handler(data_biometric_fingerprint) {

        //setIsAuthenticated((prev) => { return data_auth} );
        setBiometric_fingerprint(data_biometric_fingerprint);
    }

    function changeDeviceHandler(data_device) {

        //setIsAuthenticated((prev) => { return data_auth} );
        setDevice(data_device);
    }

    function changeSessionIDHandler(data_sessionID) {

        //alert('In changeSessionIDHandler');
        //alert(data_sessionID);
        //setIsAuthenticated((prev) => { return data_auth} );
        setSessionID(data_sessionID);
    }
    function changeSessionHandler(data_session) {

        //alert('In changeSessionIDHandler');
        //alert(data_sessionID);
        //setIsAuthenticated((prev) => { return data_auth} );
        setSession(data_session);
    }

    function changeBaseURLHandler(data_baseURL) {

        //alert('In Auth Merchant context changeBaseURLHandler');
        //alert(data_baseURL);
        //setIsAuthenticated((prev) => { return data_auth} );
        setBaseURL(data_baseURL);
    }




    function changeStartDateRangeHandler(data_startDate) {

        //alert('In changeStartDateRangeHandler');
        //alert(data_startDate);

        //setStartDateRange((prev) => { return data_startDate} );
        setStartDateRange(data_startDate);
    }

    function changeEndDateRangeHandler(data_endDate) {

        //alert('In changeEndDateRangeHandler');
        //alert(data_endDate);

        //setEndDateRange((prev) => { return data_endDate} );
        setEndDateRange(data_endDate);
    }

    function changeNumOfNightsHandler(data_numOfNights) {

        //setNumberOfNights((prev) => { return data_numOfNights} );
        setNumberOfNights(data_numOfNights);
    }


    function changeCapabilityHandler (data_capability) {

        // alert("IN changeCapabilityHandler");
        // alert(data_capability);

        //setAccessRights((prev) => { return data_accessRights} );
        setCapability(data_capability);
    }


    function changeFeatureHandler (data_feature) {
        // alert("IN changeFeatureHandler");
        // alert(data_feature );
        //setAccessRights((prev) => { return data_accessRights} );
        setFeature(data_feature);
    }

    function changeCartListHandler (data_cartList) {
        // alert("IN changeFeatureHandler");
        // alert(data_feature );
        //setAccessRights((prev) => { return data_accessRights} );
        setCartList(data_cartList);
    }

    function changeFcmTokenHandler (data_id) {

        //alert('In changeAccountIDHandler');

        //setAccountID((prev) => { return data_id} );
        setFcmToken(data_id);
    }

    function changeLatitudeCurrentHandler (data_latitudeCurrent) {

        //alert('In changeLatitudeCurrentHandler');
        //alert(data_latitudeCurrent);

        //setAccountID((prev) => { return data_id} );
        setLatitudeCurrent(data_latitudeCurrent);
    }

    function changeLongitudeCurrentHandler (data_longitudeCurrent) {

        //alert('In changeLongitudeCurrentHandler');
        //alert(data_longitudeCurrent);

        //setAccountID((prev) => { return data_id} );
        setLongitudeCurrent(data_longitudeCurrent);
    }
    function changeChatID_listHandler (data_chatID_list) {

        setChatID_list(data_chatID_list);
    }    
    function changeWebsocketHandler (data_websocket) {

        setWebsocket(data_websocket);
    }

    function changeInitialSetupHandler (data_initialSetup) {

        // alert("IN CONTEXT");
        // alert(data_initialSetup);

        setInitialSetup(data_initialSetup);
    }


    function changeSelectedTutorialHandler (data_selectedTutorial) {

        //alert("IN CONTEXT");
        //alert(data_selectedTutorial);

        setSelectedTutorial(data_selectedTutorial);
    }

    function changeSubscriptionHandler (data_subscription) {

        //alert("IN CONTEXT");
        //alert(data_selectedTutorial);

        setSubscription(data_subscription);
    }


    const context = {
        acctID: accountID,
        companyPhoneNumber: companyPhoneNumber,
        mtnCompanyPhoneNumber: mtnCompanyPhoneNumber,
        employeeID: employee_ID,
        employeeFirstName: employee_FirstName,
        employeeLastName: employee_LastName,
        employeeCompany: employee_Company,

        employeeCreatedBy: employee_createdBy,
        schema: schemaName,
        accessRights: accessRightsData,
        cookieID: cookieIdentity,
        authenticated: isAuthenticated,
        loginUsername: loginUsername_Authenticated,
        loginPassword: loginPassword_Authenticated,

        isBiometric_fingerprintAvailable: isBiometric_fingerprintAvailable_authenticated,
        biometric_fingerprint: biometric_fingerprint_authenticated,
        device: device_authenticated,
        sessionID: sessionID_authenticated,
        session: session_authenticated,
        baseURL: baseURL_authenticated,

        startDate: startDateRange,
        endDate: endDateRange,
        numOfNights: numberOfNights,
        capability: capabilityData,
        feature: featureData,

        cartList: cartListData,
        fcmToken: fcmToken_authenticated,

        latitudeCurrent: latitudeCurrent,
        longitudeCurrent: longitudeCurrent,

        chatID_list: chatID_list,
        websocket: websocket,
        initialSetup: initialSetup,
        selectedTutorial: selectedTutorial,
        subscription: subscription,

        changeAccountID: changeAccountIDHandler,
        changeCompanyPhoneNumber: changeCompanyPhoneNumberHandler,
        changemtnCompanyPhoneNumber: changemtnCompanyPhoneNumberHandler,
        changeEmployeeID: changeEmployeeIDHandler,
        changeEmployeeFirstName: changeEmployeeFirstNameHandler,
        changeEmployeeLastName: changeEmployeeLastNameHandler,
        changeEmployeeCompany: changeEmployeeCompanyHandler,

        changeEmployeeCreatedBy: changeEmployeeCreatedByHandler,
        changeSchema: changeSchemaNameHandler,
        changeAccessRights: changeAccessRightsHandler,
        changeCookieID: changeCookieHandler,
        changeAuthenticated: changeAuthenticatedHandler,
        changeLoginUsername: changeLoginUsernameHandler,
        changeLoginPassword: changeLoginPasswordHandler,

        changeIsBiometric_fingerprintAvilable: changeIsBiometric_fingerprintAvilable_handler,
        changeBiometric_fingerprint: changeBiometric_fingerprint_handler,
        changeDevice: changeDeviceHandler,
        changeSessionID: changeSessionIDHandler,
        changeSession: changeSessionHandler,
        changeBaseURL: changeBaseURLHandler,

        changeStartDateRange: changeStartDateRangeHandler,
        changeEndDateRange: changeEndDateRangeHandler,
        changeNumOfNights: changeNumOfNightsHandler,

        changeCapability: changeCapabilityHandler,
        changeFeature: changeFeatureHandler,

        changeCartList: changeCartListHandler,
        changeFcmToken: changeFcmTokenHandler,

        changeLatitudeCurrent: changeLatitudeCurrentHandler,
        changeLongitudeCurrent: changeLongitudeCurrentHandler,

        changeChatID_list: changeChatID_listHandler,
        changeWebsocket: changeWebsocketHandler,
        changeInitialSetup: changeInitialSetupHandler,
        changeSelectedTutorial: changeSelectedTutorialHandler,
        changeSubscription: changeSubscriptionHandler,

    }

    //alert('In auth_merchantID_context');

    return <Auth_MerchantID_context.Provider value={context}>
        {props.children}
    </Auth_MerchantID_context.Provider>
    
    }
    
    